var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4426 10.9381C11.4426 10.265 11.9882 9.71937 12.6613 9.71937L23.0027 9.71936C23.6758 9.71936 24.2215 10.265 24.2215 10.9381L24.2215 21.2796C24.2215 21.9526 23.6758 22.4983 23.0027 22.4983C22.3297 22.4983 21.784 21.9526 21.784 21.2796L21.784 13.8804L11.7995 23.8649C11.3236 24.3409 10.5519 24.3409 10.076 23.8649C9.6 23.389 9.6 22.6173 10.076 22.1413L20.0604 12.1569L12.6613 12.1569C11.9882 12.1569 11.4426 11.6112 11.4426 10.9381Z",
    fill: "#3AB44A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.767943b80dbc22ef40f7c5de6ba6f30b.svg";
export { ForwardRef as ReactComponent };